import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TransmedProcessSlide from "./slide";
import {
  faWhatsapp,
  faFacebookMessenger,
} from "@fortawesome/free-brands-svg-icons";
import { faFile, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { externalRedirectUrl } from "../../../page-redirect";
import { Link, useRevalidator } from "react-router-dom";
import { IMAGE_HOST } from "../../../../server/config";
import OutputTransmedReceiving from "../../../../dtos/transmed/process/receiving";
import Markdown from "react-remarkable";
import FileInput from "../../../../components/inputs/file";
import { useSetError } from "../../../generic-error";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import subtractOneSecond from "../../../../utils/subtractOneSecond";
import TransmedRegistration from "../../../../dtos/transmed/process/registration/registration";
import TransmedRegistrationPaymentService from "../../../../service/transmed/process/registration/payment";

function TransmedProcessAccepted(props: {
  registration: TransmedRegistration;
  exchangeStart: Date;
  exchangeEnd: Date;
  receiving: OutputTransmedReceiving;
  participationProofTemplate: string;
}) {
  const [loading, setLoading] = useState<boolean>(false);
  const setError = useSetError();
  const revalidator = useRevalidator();

  const [file, setFile] = useState<File | null>(null);

  return (
    <TransmedProcessSlide>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "flex-start",
          gap: "var(--gap-medium)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            gap: "var(--gap-medium)",
            flex: 3,
          }}
        >
          <h3>Felicitări!</h3>
          <div>Ai fost repartizat în</div>
          <h1>{props.registration.confirmed_lc!.city} </h1>
          <div style={{ marginTop: "calc(var(--gap-xs) - var(--gap-medium))" }}>
            (
            {props.registration.confirmed_lc_accomodation
              ? "cu cazare"
              : "fără cazare"}
            )
          </div>
          <div>
            Perioada:{" "}
            <b>
              {props.exchangeStart.toLocaleDateString("RO-ro")} -{" "}
              {props.exchangeEnd.toLocaleDateString("RO-ro")}
            </b>
          </div>
          <Markdown source={props.receiving.acceptance_message} />
          {props.registration.payment_proof_deadline && (
            <form
              onSubmit={async (e) => {
                e.preventDefault();

                setError("");
                setLoading(true);
                try {
                  if (file === null)
                    throw new Error("Selectează un fișier pentru a-l încărca");
                  await new TransmedRegistrationPaymentService().create.upload(
                    file,
                  );
                } catch (error) {
                  setError(error);
                } finally {
                  setLoading(false);
                  revalidator.revalidate();
                }
              }}
            >
              <h4
                style={{
                  marginBottom: "var(--gap-medium)",
                }}
              >
                Deadline încărcare dovadă:{" "}
                <b style={{ color: "red" }}>
                  {subtractOneSecond(
                    props.registration.payment_proof_deadline,
                  ).toLocaleDateString("RO-ro")}
                  , ora{" "}
                  {subtractOneSecond(
                    props.registration.payment_proof_deadline,
                  ).toLocaleTimeString("RO-ro")}
                </b>
              </h4>
              {props.registration.rejection_message && (
                <div
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    marginBottom: "var(--gap-medium)",
                  }}
                  className="surface"
                >
                  Există probleme cu dovada încărcată. Validatorii îți transmit
                  următorul mesaj:
                  <br />
                  <br />
                  <b>{props.registration.rejection_message}</b>
                </div>
              )}
              <FileInput
                remoteValue={props.registration.payment_proof ?? undefined}
                label="Dovada plății"
                types={["pdf"]}
                required
                multiple={false}
                onChange={(files) => {
                  if (files.length > 0) setFile(files[0]);
                }}
              />
              <div
                style={{
                  display: "flex",
                  gap: "var(--gap-small)",
                  marginTop: "var(--gap-small)",
                }}
              >
                <button
                  type="submit"
                  className="button primary"
                  disabled={
                    props.registration.payment_proof_checked &&
                    props.registration.rejection_message === null
                  }
                >
                  Încarcă
                </button>

                {(loading || revalidator.state === "loading") && (
                  <CircularProgress />
                )}
              </div>
            </form>
          )}
        </div>
        {((props.registration.payment_proof_checked &&
          props.registration.rejection_message === null) ||
          !props.registration.payment_proof_deadline) && (
          <div
            style={{
              flex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "var(--gap-medium)",
            }}
          >
            <div>
              Accesează grupul pentru partcipanții din{" "}
              {props.registration.confirmed_lc!.city}:
            </div>
            <Link
              to={externalRedirectUrl(props.receiving.whatsapp)}
              className="button primary"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "var(--gap-xs)",
              }}
            >
              <FontAwesomeIcon icon={faWhatsapp as IconDefinition} size="xl" />
              <FontAwesomeIcon
                icon={faFacebookMessenger as IconDefinition}
                size="xl"
              />
              Accesează grupul
            </Link>
            <h4>Descarcă adeverința</h4>
            <div>
              Pentru validarea orelor, e nevoie ca participarea la fiecare
              activitate didactică să fie confirmată de cadrul didactic prin
              semnarea unei adeverințe.
            </div>
            <Link
              to={externalRedirectUrl(
                IMAGE_HOST + props.participationProofTemplate,
              )}
              className="button primary outlined"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "var(--gap-xs)",
              }}
            >
              <FontAwesomeIcon icon={faFile} size="xl" />
              Descarcă adeverința
            </Link>
          </div>
        )}
      </div>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessAccepted;
